import * as XLSX from "xlsx";
export type WalletData = {
  address: string;
  privateKey: string;
  mnemonic?: string;
};

export function downloadFile(
  data: WalletData[],
  format: "json" | "csv" | "txt" | "xlsx",
  fileName = "wallets"
) {
  const now = new Date();
  const pad = (n: number) => n.toString().padStart(2, "0");

  const timestamp =
    now.getFullYear().toString() +
    pad(now.getMonth() + 1) +
    pad(now.getDate()) + "_" +
    pad(now.getHours()) +
    pad(now.getMinutes()) +
    pad(now.getSeconds());

  fileName = `SUI-Wallets-${timestamp}`;

  let blob: Blob;
  switch (format) {
    case "json":
      blob = new Blob([JSON.stringify(data, null, 2)], {
        type: "application/json",
      });
      break;

    case "csv":
      const csvHeader = "Address,PrivateKey,Mnemonic";
      const csvRows = data.map(
        (row) => `${row.address},${row.privateKey},"${row.mnemonic || ""}"`
      );
      const csvContent = [csvHeader, ...csvRows].join("\n");
      blob = new Blob([csvContent], { type: "text/csv" });
      break;

    case "txt":
      const txtContent = data
        .map(
          (w) =>
            `Address: ${w.address}\nPrivateKey: ${w.privateKey}\nMnemonic: ${w.mnemonic || ""
            }\n---`
        )
        .join("\n\n");
      blob = new Blob([txtContent], { type: "text/plain" });
      break;

    case "xlsx":
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Wallets");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      break;

    default:
      console.error("Unsupported format:", format);
      return;
  }

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${fileName}.${format}`;
  a.click();
  URL.revokeObjectURL(url);
}
